import { DEFAULT_PAGE_SIZE } from 'config/constants';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { Maybe } from 'graphql/generated';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useEffect, useRef } from 'react';
import { FriendlyUrlPageType } from 'types/friendlyUrl';
import { ListedProductType } from 'types/product';
import { useGtmContext } from 'utils/Gtm/context/GtmProvider';
import { getGtmProductsListEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmFlagProductListView = (
    data: Maybe<FriendlyUrlPageType> | undefined,
    slug: string,
    products: ListedProductType[],
    fetching: boolean,
): void => {
    const lastViewedFlagSlug = useRef<string | undefined>(undefined);
    const lastViewedFlagPage = useRef<number | undefined>(undefined);
    const { url } = useDomainConfig();
    const currentPage = useCurrentPageQuery();
    const { didPageViewRun } = useGtmContext();

    useEffect(() => {
        if (
            didPageViewRun &&
            data !== null &&
            data !== undefined &&
            data.__typename === 'Flag' &&
            (lastViewedFlagSlug.current !== slug || lastViewedFlagPage.current !== currentPage) &&
            !fetching
        ) {
            lastViewedFlagSlug.current = slug;
            lastViewedFlagPage.current = currentPage;
            const event = getNewGtmEcommerceEvent('ec.products_list', true);
            event.ecommerce = getGtmProductsListEvent(products, 'flag', currentPage, DEFAULT_PAGE_SIZE, url);
            gtmSafePushEvent(event);
        }
    }, [currentPage, data, fetching, products, slug, url, didPageViewRun]);
};
